import { render, staticRenderFns } from "./TableGeneric1.vue?vue&type=template&id=52485503&scoped=true&"
import script from "./TableGeneric1.vue?vue&type=script&lang=js&"
export * from "./TableGeneric1.vue?vue&type=script&lang=js&"
import style0 from "./TableGeneric1.vue?vue&type=style&index=0&id=52485503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52485503",
  null
  
)

export default component.exports